import axios from 'axios';
import url from '@/url';

const base = process.env.VUE_APP_SERVICE_URL + url.tenant_payment_gateways;

const authHeaders = () => ({
  headers: {
    'X-Authorization': localStorage.getItem('token'),
  },
});

const unwrap = (response) => {
  const result = response?.data?.result;
  if (result && (result.status === 200 || result.status === 201)) {
    return result.data;
  }
  return null;
};

export const listTenantGateways = async (tenantId) => {
  const response = await axios.get(`${base}${tenantId}/payment-gateways`, authHeaders());
  const data = unwrap(response);
  return Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
};

export const getTenantGateway = async (tenantId, provider) => {
  try {
    const response = await axios.get(
      `${base}${tenantId}/payment-gateways/${provider}`,
      authHeaders(),
    );
    return unwrap(response);
  } catch (err) {
    if (err?.response?.status === 404) {
      return null;
    }
    throw err;
  }
};

export const upsertTenantGateway = async (tenantId, provider, payload) => {
  const response = await axios.put(
    `${base}${tenantId}/payment-gateways/${provider}`,
    payload,
    authHeaders(),
  );
  return unwrap(response);
};

export const deleteTenantGateway = async (tenantId, provider) => {
  const response = await axios.delete(
    `${base}${tenantId}/payment-gateways/${provider}`,
    authHeaders(),
  );
  return unwrap(response);
};
